import { Button, Image, Text } from '@chakra-ui/react';
import BowlLogo from 'assets_2/images/logo/bowl-dark-shadow.webp';
import { numberConvert } from 'helpers/numerals';
import redirectToBranchAppStore from 'helpers/redirectToBranchAppStore';
import { useAnalytics } from 'hooks/useAnalytics';
import useBreakpoint from 'hooks/useBreakpoint';
import { useBranch } from 'lib/branch/BranchProvider';
import { APP_DEFAULT_DEEPLINK } from 'lib/branch/helpers';
import { GA_CLICK_EVENT_NAMES } from 'lib/firebase/ga_events';
import React, { useState } from 'react';
import useGlobalStats from 'services/admin/hooks/useGlobalStats';

type DownloadAppBannerContentProps = {
  /**
   * Function to be called when the button (Get the app) is clicked.
   * Default: will redirect user to the app store / play store.
   */
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const DownloadAppBannerContent = ({
  onClick
}: DownloadAppBannerContentProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { trackGAClickEvent } = useAnalytics();
  const { getBranchQRUrl } = useBranch();
  const { isMdScreen } = useBreakpoint();

  const { total_users, isGlobalStatsLoading } = useGlobalStats();
  const numberOfJoinedUsers = numberConvert(total_users ?? 0, true, 0);

  const onGetAppClick = () => {
    setIsLoading(true);

    getBranchQRUrl(link => {
      trackGAClickEvent({
        click_event_name: GA_CLICK_EVENT_NAMES.DOWNLOAD_APP_CLICKED
      });

      redirectToBranchAppStore(link ?? APP_DEFAULT_DEEPLINK);
      setIsLoading(false);
    });
  };

  return (
    <>
      <Text
        fontSize={{ base: '16px', md: '18px' }}
        lineHeight="21px"
        fontWeight={500}
        color="neutral.0"
        fontFamily="ProximaNova"
        mr={3}
      >
        Trusted by {!isGlobalStatsLoading ? numberOfJoinedUsers : null} people.{' '}
        <Text as="span" fontWeight={700}>
          It’s free.
        </Text>
      </Text>

      <Button
        flexShrink={0}
        paddingX="18px"
        paddingTop="8px"
        paddingBottom="9px"
        bgColor="neutral.0"
        borderRadius="8px"
        fontSize={{ base: '16px', md: '18px' }}
        lineHeight="25px"
        fontWeight={600}
        color="neutral.700"
        fontFamily="ProximaNova"
        leftIcon={
          <Image
            src={BowlLogo}
            width={{ base: '27px', md: '29px' }}
            paddingTop="2px"
            htmlWidth={isMdScreen ? 29 : 27}
            htmlHeight={18}
            alt="Insight Timer"
          />
        }
        isLoading={isLoading}
        onClick={onClick ?? onGetAppClick}
      >
        Get the app
      </Button>
    </>
  );
};

export default DownloadAppBannerContent;
